import { api } from './api';

export const fetchAppointments = async ({
    patient,
    qi,
    qf,
    only_confirmed = true,
    only_upcoming = true
}) => {
    const { data } = await api.post('/cheart/appointments', {
        patient,
        qi,
        qf,
        only_confirmed,
        only_upcoming
    });
    return data;
};

export const scheduleAppointment = async ({ patient, doctor, ts, summary }) => {
    const { data } = await api.post('/cheart/appointments/schedule', {
        patient,
        doctor,
        ts,
        summary
    });
    return data;
};

export const fetchAppointmentByUuid = async (uuid) => {
    const { data } = await api.post('/cheart/appointments/fetch', { uuid });
    return data;
};

export const addAppointmentNotes = async ({ uuid, notes }) => {
    await api.post('/cheart/appointments/notes', {
        uuid,
        notes
    });
};